<template>
  <div>
    <b-button v-show="servicesLatLng.length < 1 && !locationView" variant="link" disabled>
      <b-icon icon="map"></b-icon> No locations to display
    </b-button>

    <b-button v-show="servicesLatLng.length > 0" v-b-toggle.map-collapse variant="link">
      <b-icon icon="map"></b-icon>
      View {{ servicesLatLng.length }} services on map
    </b-button>

    <b-button v-show="locationView" v-b-toggle.map-collapse variant="link">
      <b-icon icon="map"></b-icon>
      View locations on map
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    serv: {
      type: [Object, Array],
      default() {
        return []
      },
    },
    locationView: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      serviceInfo: [],
      servicesLatLng: [],
    }
  },
  mounted() {
    this.setUpData(this.serv)
    this.processLocations()
  },
  methods: {
    setUpData(data) {
      if (typeof data != 'undefined') {
        if (this.serv.id) this.serviceInfo.push(this.serv)
        if (!this.serv.id) this.serviceInfo = this.serv
        this.processLocations()
      }
    },
    processLocations() {
      let latlon = []

      this.serviceInfo.forEach(function (sv) {
        if (sv.service_at_locations) {
          sv.service_at_locations.forEach(function (serviceLocations) {
            if (serviceLocations.location.latitude) {
              if (serviceLocations.location.latitude > 0) {
                latlon.push('x')
              }
            }
          })
        }
      })

      this.servicesLatLng = latlon
    },
  },
}
</script>
